import { CustomTerm } from './custom-terms.model';
import { ProfanityFilterEnum } from './profanity-filter.enum';

export class MonitorTerms {
  monitorProblematicInd: boolean;
  flagCurseWordsInd: ProfanityFilterEnum;
  flagGibberishInd: boolean;
  customErrorMessage: string;
  customErrorMessageInd: boolean;
  blockedTerms: CustomTerm[];
  flaggedTerms: CustomTerm[];
}
